<template>
	<div class="width-100 height-100 flex-column overflow-y-auto">
		<div class="head-container">
			<MarketplaceHeader ref="marketplace_header" />
		</div>
		<div class="content-wrapper">
			<TailorYourExperience @open-add-apps="openAddApps" class="head-container mx-5" v-if="allCalculatedDirectoryAppsIds.length === 0" />
			<MarketplaceContent />
		</div>
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { allCalculatedDirectoryAppsIds } from '@/store/modules/auth/getters';
import MarketplaceHeader from '@/components/Marketplace/MarketplaceHeader.vue';
import MarketplaceContent from '@/components/Marketplace/MarketplaceContent.vue';
import TailorYourExperience from '@/components/Marketplace/TailorYourExperience.vue';
export default {
	name: 'Marketplace',
	components: {
		MarketplaceHeader,
		MarketplaceContent,
		TailorYourExperience,
	},
	computed: {
		...mapGettersShorthand({ allCalculatedDirectoryAppsIds }),
	},
	methods: {
		openAddApps() {
			this.$refs.marketplace_header.openAddApps();
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped>
$header-height: 380px;
.head-container {
	height: $header-height;
}
.content-wrapper {
	height: calc(100% - #{$header-height});
}
</style>
